import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgDialogModule } from '@principle-theorem/ng-shared';
import { DepositConfigurationFormComponent } from './deposit-configuration-form/deposit-configuration-form.component';
import { type IDepositTreatmentTemplateRow } from './deposit-treatment-template-rows';
import { DepositTreatmentTemplateFormGroup } from './deposit-treatment-template.formgroup';

export interface IDepositTemplateConfigDialogData {
  readonly row: IDepositTreatmentTemplateRow;
}

@Component({
  selector: 'pr-deposit-template-config-dialog',
  templateUrl: './deposit-template-config-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgDialogModule,
    MatSlideToggleModule,
    DepositConfigurationFormComponent,
  ],
})
export class DepositTemplateConfigDialogComponent {
  private readonly _dialogRef = inject(
    MatDialogRef<DepositTemplateConfigDialogComponent>
  );
  private readonly _snapshot: ReturnType<
    DepositTreatmentTemplateFormGroup['getRawValue']
  >;
  private readonly _snapshotInheritsCaptureStrategy: boolean;
  private readonly _snapshotDirty: boolean;
  readonly data = inject<IDepositTemplateConfigDialogData>(MAT_DIALOG_DATA);
  readonly form = this.data.row.form;

  constructor() {
    this._snapshot = this.form.getRawValue();
    this._snapshotInheritsCaptureStrategy = this.form.inheritsCaptureStrategy;
    this._snapshotDirty = this.form.dirty;
  }

  cancel(): void {
    this.form.reset(this._snapshot, { emitEvent: false });
    if (this._snapshotInheritsCaptureStrategy) {
      this.form.restoreInheritedCaptureStrategy();
    }
    if (this._snapshotDirty) {
      this.form.markAsDirty();
    }
    this.form.updateAmountValidators();
    this.form.updateValueAndValidity({ emitEvent: false });
    this._dialogRef.close();
  }

  apply(): void {
    this._dialogRef.close();
  }
}
